<script setup lang="ts">
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'

withDefaults(defineProps<{
  height?: string
  width?: string
}>(), {
  height: '270px',
  width: '100%'
})
</script>

<template>
  <AuSkeletonWrapper
    class="overflow-hidden rounded-2xl"
    :style="{ height, width }"
  >
    <AuSkeleton
      class="motion-safe:animate-fade-in-up"
      width="100%"
      height="100%"
    />
  </AuSkeletonWrapper>
</template>
